import { render, staticRenderFns } from "./WebsiteStages.vue?vue&type=template&id=5417dd1b&scoped=true"
import script from "./WebsiteStages.vue?vue&type=script&lang=js"
export * from "./WebsiteStages.vue?vue&type=script&lang=js"
import style0 from "./WebsiteStages.vue?vue&type=style&index=0&id=5417dd1b&prod&scoped=true&lang=css"
import style1 from "./WebsiteStages.vue?vue&type=style&index=1&id=5417dd1b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5417dd1b",
  null
  
)

export default component.exports